import { Fragment, type ReactNode } from "react";
import { cn } from "../lib/utils";

export type TimeLineProps = {
	items: {
		id: string;
		label?: ReactNode;
		anchorOffsetTop?: number;
		el: ReactNode;
	}[];
};

export const TimeLine = ({ items }: TimeLineProps) => {
	return (
		<div className="grid grid-cols-[auto_auto_1fr] gap-x-[16px] w-full">
			{items.map((item, index) => (
				<Fragment key={item.id}>
					<div className="flex h-full">
						{item.label !== undefined && (
							<div
								className={cn(
									"flex text-[12px] font-[525] text-tertiary w-full h-fit",
									item.anchorOffsetTop !== undefined
										? `!mt-[${(item.anchorOffsetTop - 5).toString()}px]`
										: "justify-center",
								)}
							>
								{item.label}
							</div>
						)}
					</div>
					<div className="flex flex-col items-center h-full">
						<div
							className={cn(
								"w-[1.5px] bg-gray-100",
								item.anchorOffsetTop !== undefined ? `h-[${item.anchorOffsetTop}px]` : "flex-1",
							)}
						></div>
						<div className="w-[9px] h-[9px] border-[1.9px] border-gray-400/50 rounded-full"></div>
						<div className="w-[1.5px] flex-1 bg-gray-100"></div>
					</div>
					<div className="ml-[16px]">{item.el}</div>
					{index < items.length - 1 && (
						<>
							<div></div>
							<div className="flex flex-col items-center h-full">
								<div className="w-[1.5px] h-[24px] bg-gray-100"></div>
							</div>
							<div></div>
						</>
					)}
				</Fragment>
			))}
		</div>
	);
};
